<script>
import { ref, computed, inject, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import useMapUtils from '@/compostables/useMapUtils';

export default {
    name: 'GeofenceMarker',
    props: {
        driver: {
            type: Object,
            default: () => {}
        },
        stopDetails: {
            type: Object,
            default: () => {}
        },
        geofenceDetails: {
            type: Object,
            default: () => {}
        }
    },
    setup(props, { root }) {
        const { getters } = inject('vuex-store');
        const map = inject('map');
        const google = inject('google');
        const bounds = inject('bounds');
        const { setMarkers } = useMapUtils(root);

        const pinnedUser = computed(() => getters['map/pinnedUser']);
        const isGeofenceToggled = computed(() => getters['map/isGeofenceToggled']);
        const marker = ref(null);

        const {
            driver: { publicUserId, markerPins },
            stopDetails: { address, stopRef, stopId },
            geofenceDetails: { oldStatus, newStatus, actionDate, location, utcOffset }
        } = props;

        onMounted(() => {
            const { latitude, longitude } = location;
            marker.value = setMarkers(google.value, map.value, latitude, longitude, 'geofence', markerPins);

            if (!pinnedUser.value || pinnedUser.value !== publicUserId) 
                marker.value.setMap(null);
            if (!isGeofenceToggled.value) 
                marker.value.setMap(null);

            const data = { address, stopRef, oldStatus, newStatus, actionDate, stopId, location, utcOffset };
            marker.value.addListener('click', () => {
                root.$emit('marker-clicked', { data, marker: marker.value, type: 'geofence' });
            });
        });

        onBeforeUnmount(() => {
            marker.value.setMap(null);
            marker.value = null;
        });

        watch(pinnedUser, (newVal) => {
            // unpinning a user
            if (!newVal) 
                marker.value.setMap(null);

            if (newVal === publicUserId) {
                marker.value.setMap(map.value);
                bounds.value.extend(marker.value.getPosition());
            } else 
                marker.value.setMap(null);
        });

        watch(isGeofenceToggled, (newVal) => {
            marker.value.setMap(newVal ? map.value : null);
        });

        return {
            marker
        };
    },
    render: () => null
};
</script>
